<template>
  <div style="margin: 10px 20px">
    <b-row class="align-items-center not-print">
      <b-col cols="4">
        <SalesmanSearch :name="salesman_name.value" @selected="setSalesman($event)" />
      </b-col>
      <b-col cols="4">
        <CategorySearch :name="category_name.value" @selected="setCategory($event)" />
      </b-col>
      <b-col cols="4">
        <search-input :alias="'Produto'" :name="'product_base_id'" :ref="'searchProductInput'"
          :isLoading="productIsLoading" :searchResult="searchProductResults" v-model="searchParams.product_base_id"
          :displayedValue="searchParams.product.description" @search="searchProduct($event)"
          @selected="setProductValue($event)">
          <search-input-option tabindex="0" :key="index" :index="index" @click="setProductValue(row, false)"
            v-for="(row, index) in searchProductResults.data">
            <div class="d-flex justify-content-between">
              <div>
                <small class="text-muted">{{ row.base_sku_id }}</small>
                - {{ row.description }}
                <br />
                <small class="text-muted">{{ row.brand }} &nbsp;</small>
              </div>
            </div>
          </search-input-option>
        </search-input>
      </b-col>
      <b-col cols="3">
        <date-input v-model="searchParams.start_date" alias="Data Inicial" />
      </b-col>
      <b-col cols="3">
        <date-input v-model="searchParams.end_date" alias="Data Final" />
      </b-col>
      <b-col class="d-flex mt-3">
        <b-btn @click="clear()" class="mr-4" size="sm"><i class="fas fa-times mr-1" /> Limpar Filtro</b-btn>
        <b-btn variant="primary" size="sm" @click="select()"><i class="fas fa-search mr-1" /> Pesquisar</b-btn>
        <b-btn class="ml-auto" variant="primary" size="sm" @click="print()"><i class="fas fa-print mr-1" />
          Imprimir</b-btn>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table small responsive class="card" :fields="fields" :items="order_products">
          <template #thead-top>
            <b-tr>
              <b-td class="p-0" colspan="8">
                <b-card style="border: 0px">
                  <template #header>
                    <h4 class="text-center">
                      Relatório Venda de Produtos por Vendedor
                    </h4>
                  </template>
                  <b-row class="align-items-end">
                    <b-col class="d-flex flex-column">
                      <span v-if="searchParams.salesman_id">
                        {{ salesman_name.value }}
                      </span>
                      <template v-if="searchParams.product_base_id">
                        <span>
                          Produto Especificado:
                          {{ searchParams.product.description }}
                        </span>
                        <span>
                          Total de Unidades Vendidas:
                          {{ total_quantity_sold | decimal }}
                        </span>
                      </template>
                      <span>
                        Período de pesquisa:
                        {{ searchParams.start_date | dateBr }} até
                        {{ searchParams.end_date | dateBr }}
                      </span>
                      <span>
                        Valor Total em Vendas {{ total_sales_value | moneyBr }}
                      </span>
                    </b-col>
                    <b-col class="text-right">
                      <span class="font-weight-bold">
                        Consulta Realizada : 08/04/2022 08:11
                      </span>
                    </b-col>
                  </b-row>
                </b-card>
              </b-td>
            </b-tr>
          </template>
          <template #cell(product)="data">
            {{ data.item.product_base.description }}
          </template>

          <template #cell(quantity_sold)="data">
            {{ data.item.quantity_sold | decimal(3) }}
            {{ data.item.unit }}
          </template>
          <template #cell(total_sales_value)="data">
            {{ data.item.total_sales_value | moneyBr }}
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";

import SalesmanSearch from "@/components/SalesmanSearch.vue";
import CategorySearch from "@/components/CategorySearch.vue";

export default {
  components: { SalesmanSearch, CategorySearch },
  data() {
    return {
      order_products: [],

      total_sales_value: null,
      total_quantity_sold: null,
      salesman_name: {},
      category_name: {},
      searchParams: {
        product: {},
        start_date: moment().subtract(30, "days").format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
        product_base_id: null,
        category_id: null,
      },

      fields: [
        {
          key: "product",
          label: "Produto",
          class: "text-center",
        },
        {
          key: "salesman_name",
          label: "Vendedor",
          class: "text-center",
        },

        {
          key: "quantity_sold",
          label: "Unidades Vendidas",
          class: "text-center",
          sortable: true,
        },
        {
          key: "total_sales_value",
          label: "Valor  em Vendas",
          class: "text-center",
          sortable: true,
        },
      ],

      productIsLoading: false,

      searchProductResults: {},
    };
  },

  mounted() {
    this.$store.commit("pageHasLoaded");
    this.select();
  },

  methods: {
    setSalesman(salesman) {
      this.salesman_name.value = salesman.name;
      this.searchParams.salesman_id = salesman.id;
    },

    setCategory(category) {
      this.category_name.value = category.description;
      this.searchParams.category_id = category.id;
    },

    select() {
      this.$store
        .dispatch("order/getOrderOfProductsBySalesman", this.searchParams)
        .then((response) => {
          this.order_products = response.data.order_products;
          this.total_sales_value = response.data.total_sales_value;
          this.total_quantity_sold = response.data.total_quantity_sold;
        })
        .catch((error) => { });
    },

    searchProduct(params) {
      let description = params.text;

      this.postSearch(description, params.page, false);
    },

    setProductValue(product) {
      this.searchParams.product = product;
      this.searchParams.product_base_id = product.id;
      this.select();
    },

    postSearch(text, page) {
      this.productIsLoading = true;
      axios
        .post(
          process.env.BASE_URL + "api/searchproductorder/select?page=" + page,
          {
            description: text,
          }
        )
        .then((response) => {
          this.searchProductResults = response.data;

          if (this.searchProductResults.data.length == 0) {
            this.$store.commit("showAlert", {
              message: "Produto não cadastrado",
              variant: "info",
            });
          }

          this.productIsLoading = false;
        })
        .catch((error) => {
          this.productIsLoading = false;
        });
    },
    clear() {
      this.searchParams = {
        start_date: moment().subtract(30, "days").format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
        salesman_id: null,
        product: {},
        product_base_id: null,
        category_id: null,
      };
      this.salesman_name.value = null;
      this.category_name.value = null;

      this.select();
    },
    print() {
      window.print();
    },
  },
};
</script>
<style scoped>
body {
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  color: rgb(0, 0, 0);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-size: 11pt;
}

* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.page {
  width: 297mm;
  min-height: 210mm;
  padding: 0.5cm;
  margin: 0.5cm;
  border: 1px #d3d3d3 solid;
  /*    border-radius: 5px;*/
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

.subpage {
  padding: 0cm;
  /*    border: 5px red solid;*/
  height: 256mm;
  outline: 2cm #ffeaea solid;
}

@page {
  size: A4;
  margin: 0.5cm;
  padding: 0.5cm;
}

@media print {
  .page {
    visibility: visible;
    margin: initial;
    border: rgba(0, 0, 0, 0.1);
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }

  .not-print {
    display: none;
  }
}

hr.color {
  border: 1px solid black;
}
</style>
